export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-kiln text-white font-rounded">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 pb-10 border-b border-kiln-light/30">
          {/* Col 1 */}
          <div>
            <img
              src="https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/edd47a446067e1e8e41fdfab79098def.png"
              alt="ふぅばてぇ(FUBATE)"
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-white/70 text-sm leading-relaxed mb-5">
              奄美大島・宇検村の入口にある<br />
              手ごねピザのテイクアウト専門店。<br />
              400℃の窯で焼きたてをどうぞ。
            </p>
            <a
              href="https://www.instagram.com/nakamura0v0kensetsu.ukenson/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-tankan-light hover:text-tankan text-sm font-medium cursor-pointer transition-colors"
            >
              <i className="ri-instagram-line text-lg" />
              @nakamura0v0kensetsu.ukenson
            </a>
          </div>

          {/* Col 2 */}
          <div>
            <p className="text-xs font-bold tracking-widest text-white/40 mb-4 uppercase">Navigation</p>
            <nav className="flex flex-col gap-2">
              {[
                { href: '#about', label: 'お店について' },
                { href: '#craft', label: 'こだわり' },
                { href: '#menu', label: 'メニュー' },
                { href: '#story', label: 'ストーリー' },
                { href: '#access', label: 'アクセス' },
                { href: '#contact', label: 'お問い合わせ' },
              ].map((link) => (
                <button
                  key={link.href}
                  onClick={() => handleNavClick(link.href)}
                  className="text-left text-white/70 hover:text-white text-sm cursor-pointer transition-colors whitespace-nowrap"
                >
                  {link.label}
                </button>
              ))}
            </nav>
          </div>

          {/* Col 3 */}
          <div>
            <p className="text-xs font-bold tracking-widest text-white/40 mb-4 uppercase">Shop Info</p>
            <ul className="space-y-2 text-sm text-white/80">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-2-line text-tankan-light mt-0.5 flex-shrink-0" />
                <span>〒894-3301 鹿児島県大島郡宇検村湯湾字大畑1869-4</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-tankan-light flex-shrink-0" />
                <a href="tel:0997-69-4091" className="hover:text-white cursor-pointer">0997-69-4091</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-tankan-light flex-shrink-0" />
                <span>10:00〜18:00</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-calendar-line text-tankan-light flex-shrink-0" />
                <span>火・水・金・土・日　定休：月・木</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">© 2026 ふぅばてぇ(FUBATE)　奄美大島・宇検村</p>
          <div className="flex items-center gap-4">
            <a href="https://tatsumisou.iyasaka-web.com/" target="_blank" rel="noopener noreferrer" className="text-white/30 text-xs hover:text-white/50 transition-colors">たつみ荘</a>
            <a href="https://iyasaka-web.com/" target="_blank" rel="nofollow noopener noreferrer" className="text-white/30 text-xs hover:text-white/50 transition-colors">弥栄web</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
